import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import permissions from './modules/permissions'
import auth from './modules/auth'
import stores from './modules/stores'
import combos from './modules/combos'
import users from './modules/users'
import { environment } from '@/global'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    permissions,
    auth,
    stores,
    combos,
    users
  },
  actions: {},
  strict: environment === 'development',
  plugins: [
    createPersistedState({
      reducer: state => ({
        'permissions': state.permissions,
        'auth': state.auth,
        'stores': {
          'activeLocation': state.stores.activeLocation
        }
      })
    })
  ]
})

export default store
